import React from "react";

interface InstructorSlideButtonProps {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  onClickTab: (value: string) => void;
  isActive:boolean;
}

const InstructorSlideButton: React.FC<InstructorSlideButtonProps> = ({
  label,
  checked,
  onChange,
  onClickTab,
  isActive
}) => {
  return (

    <div
      className={`
          text-sm font-semibold px-4 py-1.5   gap-2
          flex items-center justify-center
          border border-[#007070]
          transition-all duration-300 ease-in-out  text-black rounded accent-greenBg
          ${isActive ? "bg-greenBg text-white":""}
        `}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={() => onChange(!checked)}

      />
      <button className="w-full h-full" onClick={() => {
        onClickTab(label)
      }}>

        {label}
      </button>
    </div>
  );
};

export default InstructorSlideButton;
